import "./App.css";
import Home from "./Components/Home";
import About from "./Components/About ";
import FoodImages from "./Components/Review";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <About />
      <FoodImages />
      <Footer />
    </div>
  );
}

export default App;
